module.exports = __webpack_public_path__ + "static/contact-2ae17a3f949eea9086753f5a922640cf.svg";